import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default function AddresModalProvider(props) {
  const address = props.model;

  const [ubigeos, setUbigeos] = useState([]);
  async function getUbigeo() {
    let response = await wsGetAll('base/ubigeo');
    if (response.success) {
      setUbigeos(response.data);
    }
  }

  const [dataChanging, setDataChanging] = useState(address);

  /**
   * Address2 es un campo de 50
   * Street de 100
   * Al editar tiene que mostrarse Street
   * En el backendse seteea Street con 100 y address con substring de 50
   */
  function handleChange(field, value) {
    if (field === 'Address2') {
      setDataChanging({
        ...dataChanging,
        Address2: value,
        Street: value
      });
    } else {
      setDataChanging({
        ...dataChanging,
        [field]: value
      });
    }
  }

  useEffect(() => {
    if (address.open) {
      getUbigeo();
    }
  }, [address.open]);

  return (
    <Modal
      title="Dirección"
      model={address}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      dataForce={{ base_business_partner_id: props.bPartnerId }}
      entity="base/address"
    >
      <FormControl fullWidth margin="normal" size="small" required>
        <InputLabel>Tipo</InputLabel>
        <Select
          defaultValue={address.AdresType || 'S'}
          inputProps={{
            name: 'AdresType'
          }}
          disabled
          /* disabled={'id' in address} */
        >
          <MenuItem value="B">Fiscal</MenuItem>
          <MenuItem value="S">Entrega</MenuItem>
        </Select>
      </FormControl>
      {ubigeos.length > 0 ? (
        <Autocomplete
          options={ubigeos}
          defaultValue={
            !!address ? ubigeos.find((item) => item.id == address.base_ubigeo_id) : undefined
          }
          getOptionLabel={(option) => {
            return `${option.U_SYP_DEPA}, ${option.U_SYP_PROV}, ${option.U_SYP_DIST}`;
          }}
          renderInput={(params) => (
            <TextField {...params} label="Buscar lugar..." margin="normal" size="small" />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_ubigeo_id', item.id);
            }
            handleChange('base_ubigeo_id', null);
          }}
        />
      ) : undefined}
      <TextField
        label="Dirección"
        fullWidth
        name="Address2"
        margin="normal"
        size="small"
        defaultValue={address.Street || address.Address2 || ''}
        required
      />
      <TextField
        label="Referencia"
        fullWidth
        name="adress_reference"
        margin="normal"
        size="small"
        defaultValue={address.adress_reference || ''}
      />
    </Modal>
  );
}
